import React, { Fragment, useState, useEffect } from 'react';
import AudioFileAdmisionList from './AudioFileAdmisionList';
import AudioFileAdmisionActions from './AudioFileAdmisionActions';
import Spinner from 'react-bootstrap/Spinner';

const AudioFileAdmisionListData = ({ id_admision }) => {
    const [loading, setLoading] = useState(false);
    const [admisionAudios, setAdmisionAudios] = useState([]);

    const listAudio = async () => {
        setLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-audios/listar?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error");
            }
        }).then(res => {
            setAdmisionAudios(res);
            setLoading(false);
        }).catch(error => {
            console.log(error);
            setAdmisionAudios([]);
            setLoading(false);
        });
    }

    const refresh = async () => {
        await listAudio();
    }

    useEffect(() => {
        refresh();
    }, []);

    return (
        <Fragment>
            {
                loading == false ? <AudioFileAdmisionList
                    reactTableData={admisionAudios}
                    ReactTableActions={AudioFileAdmisionActions}
                    refresh={refresh}
                />
                    :
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
            }
        </Fragment>)
}

export default React.memo(AudioFileAdmisionListData);